import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { api } from "@/lib/api";
import { BottomTab } from "@/components/BottomTab";

const FORMAT_BULLETS = [
  "Ranking Workout — la prova che determina il livello e stabilisce il percorso degli atleti nei Games.",
  "3 Games — tre prove diverse per mettere alla prova forza, abilità e resistenza.",
  "4 Semi — Picche, Fiori, Quadri e Cuori determinano la categoria e il livello di ogni player.",
  "Battle numerose — fino a 6 atleti contemporaneamente in campo, con sorpassi e confronti diretti.",
  "Campo dinamico — qui la classifica si vede. Gli atleti avanzano tra gli attrezzi, si sfidano e cambiano posizione sotto gli occhi del pubblico.",
  "Finali — una finale per ogni seme, fino all'elezione di Re e Regina.",
  "Un Game da vivere — pubblico, musica, atmosfera e competizione fanno parte dello spettacolo.",
];

export default function Dettagli() {
  const nav = useNavigate();
  const [event, setEvent] = useState(null);

  useEffect(() => {
    api.get("/event").then((r) => setEvent(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen pb-24 bg-surface" data-testid="dettagli-page">
      <header className="bg-black px-4 pb-5 flex items-center gap-3" style={{ paddingTop: "calc(var(--safe-top) + 16px)" }}>
        <button data-testid="dettagli-back-btn" onClick={() => nav("/event")} className="text-white">
          <ChevronLeft size={32} strokeWidth={2.5} />
        </button>
        <h1 className="text-2xl font-black text-white">Dettagli</h1>
      </header>

      <div className="px-5 pt-5">
        <div className="bg-surface2 rounded-3xl p-6">
          {(event?.description || "").split("\n").map((line, i) =>
            line.trim() === "" ? (
              <div key={`${i}-${line}`} className="h-3" />
            ) : (
              <p key={`${i}-${line}`} className="text-onsurface leading-relaxed text-[15px] font-medium">{line}</p>
            )
          )}
        </div>

        <h2 className="font-black text-2xl text-onsurface mt-8 mb-4">Format Gara</h2>
        <div className="space-y-3">
          {FORMAT_BULLETS.map((b) => (
            <div key={b} className="flex gap-3 bg-surface2 rounded-2xl px-4 py-3">
              <span className="text-brand font-black shrink-0">▸</span>
              <p className="text-onsurface text-[15px] font-medium leading-snug">{b}</p>
            </div>
          ))}
        </div>
      </div>

      <BottomTab />
    </div>
  );
}
